<div *ngIf="(isLoading | async)" class="overlay">
    <mat-spinner
        class="spinner">
    </mat-spinner>
</div>